<div id="wrapper" [ngClass]="{'toggled':(isCollapsed$ | async), 'toggled-knowledge':(isCollapseKnowledge$ | async)}">

  <app-leftbar></app-leftbar>

  <app-topbar></app-topbar>

  <section id="content-wrapper">
    <router-outlet></router-outlet>
  </section>

</div>

<div id="el_capture_overlay"
  style="position: absolute; top: 0px; left: 0px; width: 100%; height: 100%;z-index: 1000; pointer-events: none;">
  <div id="zoneSelect" #zoneSelect
    style="background-color:none;position: fixed;border: 2px dashed #060955;border-radius: 3px;cursor:pointer;"></div>
</div>

<div class="bugButton">
  <p *ngIf="!this.bug" appDraggableY [storageKey]="'reportBugY'" (click)="openBug()">Report Bug</p>
  <div *ngIf="this.bug" class="">
    <button class="button-exit" (click)="openBug()"><img src="../../assets/images/reject.png" width="20"></button>
    <app-screenshot-ticket></app-screenshot-ticket>

  </div>
</div>

<app-skynetix-assistant></app-skynetix-assistant>
